import {
  BIKE_LOADING,
  BIKE_ERROR,

  BIKE_GET_STATUSES,
  BIKE_LIST,
  BIKE_LIST_NO_PAGINATION,
  BIKE_GET_SINGLE,
  BIKE_FILTERS,
  BIKE_UPDATE_STATUS,
  BIKE_UPDATE,

  BIKE_GET_ALERT_TYPES,
  BIKE_GET_ALERTS,
  BIKE_SET_ALERT,
} from "actions/bike/constants";

const initialState = {
  loading: false,
  errors: [],

  statuses: [],
  list: {},
  listNoPagination: [],
  listNoPaginationFilteredIdArr: [],
  single: {},
  serverFilters: [],

  alertTypes: [],
  alerts: []
};

export default function (state = initialState, action) {
  let index,
    list,
    listNoPagination,
    single,
    alerts;
  switch (action.type) {
    case BIKE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case BIKE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case BIKE_GET_STATUSES:
      return {
        ...state,
        errors: [],
        statuses: action.payload.content,
      };
    case BIKE_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case BIKE_LIST_NO_PAGINATION:
      return {
        ...state,
        loading: false,
        errors: [],
        listNoPagination: action.payload,
        listNoPaginationFilteredIdArr: action.payload.map(item => item.id)
      };
    case BIKE_FILTERS:
      return {
        ...state,
        errors: [],
        serverFilters: action.payload.content,
      };
    case BIKE_GET_SINGLE:
      return {
        ...state,
        errors: [],
        loading: false,
        single: action.payload,
      };
    case BIKE_UPDATE_STATUS:
      list = Object.assign({}, state.list);
      if (list.content && Array.isArray(list.content)) {
        index = list.content.findIndex(item => item.id === action.payload.id);
        if (index > -1) {
          list.content[index].status = action.payload.status;
        }
      }

      listNoPagination = Object.assign([], state.listNoPagination);
      if (listNoPagination.length) {
        index = listNoPagination.findIndex(item => item.id === action.payload.id);
        if (index > -1) {
          listNoPagination[index].status = action.payload.status;
        }
      }

      single = Object.assign({}, state.single);
      if (single && single.id === action.payload.id) {
        single.status = action.payload.status;
      }
      return {
        ...state,
        errors: [],
        loading: false,
        list,
        listNoPagination,
        single
      };
    case BIKE_UPDATE:
      list = Object.assign({}, state.list);
      if (list.content && Array.isArray(list.content)) {
        index = list.content.findIndex(item => item.id === action.payload.id);
        if (index > -1) {
          list.content[index] = action.payload;
        }
      }
      single = Object.assign({}, state.single);
      if (single && single.id === action.payload.id) {
        single = action.payload;
      }
      return {
        ...state,
        errors: [],
        loading: false,
        list,
        single
      };
    case BIKE_GET_ALERT_TYPES:
      return {
        ...state,
        errors: [],
        loading: false,
        alertTypes: action.payload.content
      };
    case BIKE_GET_ALERTS:
      return {
        ...state,
        errors: [],
        loading: false,
        alerts: action.payload.content
      };
    case BIKE_SET_ALERT:
      alerts = Object.assign([], state.alerts);
      alerts.unshift(action.payload);
      return {
        ...state,
        alerts
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bikeReducer.js